import { useState } from 'react'
import { errBanner, okBanner } from '@ui/admin'
import { btn, btnBase, btnSize, cx, hint } from '@ui/classes'
import {
  getAtolDiagnostics,
  type AtolDiagnosticsInfo
} from '@core/native/atolDiagnostics'
import { db } from '@core/db/db'
import { META_DEVICE_TOKEN } from '@core/db/schema'
import { CLOUD_API } from '@core/pages/admin/shared'
import { syncService } from '@core/services/sync/SyncService'

/** Диагностика Android-контура АТОЛ (без adb и без остановки кассы). */
export function AtolDiagnosticsCard() {
  const [info, setInfo] = useState<AtolDiagnosticsInfo | null>(null)
  const [busy, setBusy] = useState(false)
  const [upload, setUpload] = useState<'ok' | 'error' | 'local' | null>(null)

  const check = async () => {
    setBusy(true)
    setUpload(null)
    try {
      const next = await getAtolDiagnostics()
      setInfo(next)

      if (next.platform !== 'android') {
        setUpload('local')
        return
      }
      const tokenEntry = await db.meta.get(META_DEVICE_TOKEN)
      const token = typeof tokenEntry?.value === 'string' ? tokenEntry.value : ''
      if (!token) {
        setUpload('local')
        return
      }
      const deviceId = await syncService.ensureDeviceId()
      const response = await fetch(`${CLOUD_API}/remote/diagnostics`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          device_id: deviceId,
          app_version: next.appVersion ?? import.meta.env.VITE_APP_VERSION ?? '0.1.0',
          diagnostics: next
        })
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      setUpload('ok')
    } catch (error) {
      console.warn('[AtolDiagnosticsCard] diagnostics upload failed:', error)
      setUpload('error')
    } finally {
      setBusy(false)
    }
  }


  return (
    <div>
      {!info && (
        <p className={hint}>
          Проверяет версию Android, ABI и наличие ATOL Android Service. На web/Electron
          доступна только заглушка.
        </p>
      )}
      <button
        type="button"
        onClick={() => void check()}
        disabled={busy}
        className={cx(btnBase, btn.secondary, btnSize.sm)}
      >
        {busy ? 'Проверка…' : 'Проверить устройство'}
      </button>

      {info && (
        <div className="mt-3 space-y-1 text-small">
          <div>Платформа: {info.platform}</div>
          <div>
            Версия APK: {info.appVersion ?? '—'}
            {info.appVersionCode ? ` (versionCode ${info.appVersionCode})` : ''}
          </div>
          <div>Android SDK: {info.sdkInt ?? '—'} ({info.release ?? '—'})</div>
          <div>Модель: {info.manufacturer ?? '—'} {info.model ?? '—'}</div>
          <div>ABI: {info.abis ?? '—'}</div>
          <div>
            ATOL Android Service: {info.atolServiceInstalled ? 'установлен' : 'не найден'}
            {info.atolServiceVersion ? ` · ${info.atolServiceVersion}` : ''}
          </div>
          {info.error && <p className={errBanner}>{info.error}</p>}
        </div>
      )}
      {upload === 'ok' && (
        <p className={okBanner}>Диагностика отправлена в облако</p>
      )}
      {upload === 'error' && (
        <p className={errBanner}>Не удалось отправить диагностику в облако</p>
      )}
      {upload === 'local' && (
        <p className={hint}>Локально: облако не подключено — результаты не отправлены</p>
      )}
    </div>
  )
}
